import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import IndicatorsContext from './IndicatorsContext';
import Circle from '@mui/icons-material/Circle';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

const excludedStatuses = ["DE_BAJA", "USO_PARTICULAR", "EN_CONCESIONARIO", "EN_VENTA", "DEVOLUCION_A_TERCEROS"];

const statusesHiddenFromCards = ["A_ASIGNAR", "DEVOLUCION_A_TERCEROS"];

const statusOrder = [
  "ALQUILADO",
  "A_ENTREGAR",
  "DISPONIBLE",
  "A_REVISAR",
  "EN_REPARACION",
  "EN_TRANSLADO",
  "A_ASIGNAR",
  "TRANSPORTE",
  "OPERATIVO_BASE",
  "EN_CONCESIONARIO",
  "EN_VENTA",
  "USO_PARTICULAR",
  "DE_BAJA",
  "DEVOLUCION_A_TERCEROS"
];

export default function () {
  const navigate = useNavigate();

return (
  <IndicatorsContext.Consumer>
    {context => {
      const getTotalVehicles = () =>
        context.indicators.vehicles
          .map((it: any) =>
            it.detUnitDates.filter(
              (det: any) => !excludedStatuses.includes(det.status)
            ).length
          )
          .reduce((a: number, b: number) => a + b, 0);

      const getOrderedByStatus = () =>
        [...context.indicators.vehicles].sort(
          (a: any, b: any) =>
            statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)
        );

      const getPercentage = (value: any, vehicle: any) => {
        const totalVehicles = getTotalVehicles();

        if (excludedStatuses.includes(vehicle.status)) {
          return "N/A";
        }

        if (totalVehicles <= 0 || !value) {
          return "0%";
        }

        const percentage = (value / totalVehicles) * 100;

        return percentage < 0.1 ? "<0.1%" : `${percentage.toFixed(1)}%`;
      };

      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 3,
            fontFamily: "'Inter', sans-serif",
          }}
        >
          {/* Card principal total vehículos */}
          <Box
            sx={{
              backgroundColor: "#f9fafb",
              borderRadius: 3,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              p: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              transition:
                        "transform 0.15s ease, box-shadow 0.15s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                      },
            }}
            onClick={() => {
              navigate("/web/vehicleFleet");
            }}
          >
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 600, color: "#103115" }}>
                <Trans i18nKey={`screens.indicators.vehiclesTitle`} />
              </Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: "2rem", fontWeight: 600, color: "#103115" }}
              >
                {getTotalVehicles()}
              </Typography>
            </Box>
            
          </Box>

          {/* Cards por estado en diseño moderno */}
          {getTotalVehicles() > 0 && (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "repeat(2, 1fr)",
                  sm: "repeat(3, 1fr)",
                  md: "repeat(4, 1fr)",
                  lg: "repeat(5, 1fr)",
                },
                gap: 2.5,
              }}
            >
              {getOrderedByStatus()
                .filter((vehicle: any) => !statusesHiddenFromCards.includes(vehicle.status))
                .map((vehicle: any, index: number) => {
                const percentage = getPercentage(
                  vehicle.detUnitDates.length,
                  vehicle
                );
                const isExcluded = excludedStatuses.includes(vehicle.status);

                return (
                  <Box
                    key={index}
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: 2,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      cursor: "pointer",
                      borderTop: `6px solid ${
                        isExcluded ? "#8a9597" : "#7DD02B"
                      }`,
                      borderLeft: "2px solid #ccc",
                      borderRight: "2px solid #ccc",
                      borderBottom: "2px solid #ccc",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 2,
                      minHeight: 130,
                      transition:
                        "transform 0.15s ease, box-shadow 0.15s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 6px 15px rgba(0,0,0,0.5)",
                      },
                    }}
                    onClick={() =>
                      navigate("/web/vehicleFleet", { state: vehicle.status })
                    }
                  >
                    {/* Estado */}
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: 600,
                        color: isExcluded ? "#8a9597" : "#103115",
                        textTransform: "uppercase",
                        mb: 0.5,
                      }}
                    >
                      <Trans
                        i18nKey={`models.unitStatus.labels.${vehicle.status}`}
                      />
                    </Typography>

                    {/* Cantidad */}
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 700,
                        color: "#111827",
                        lineHeight: 1.2,
                      }}
                    >
                      {vehicle.detUnitDates.length}
                    </Typography>

                    {/* Porcentaje */}
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        color: "#6b7280",
                        mt: 0.3,
                      }}
                    >
                      ({percentage})
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          )}
        </Box>
      );
    }}
  </IndicatorsContext.Consumer>
);


}